import { Controller } from '@hotwired/stimulus'
import { toggleClass } from 'utils/toggle_class'

export default class extends Controller {

  static values = { activeAnchorClass: String }

  initialize() {
    this.activeAnchorClassValue = this.element.dataset.scrollspyActiveAnchorClassValue || "-active"
    this.links = Array.from(this.element.querySelectorAll('a[href^="#"]'))
    this.linkToAnchorMap = this.links.reduce((acc, link) => {
      const href = link.attributes["href"].value
      acc[link] = document.querySelector(href)
      if(acc[link] === null) { throw new Error(`A link that is being used for scrollspy points to an anchor that doesn't exist: ${href}.`) }
      return acc
    }, {})
    const root = this.element.getRootNode()
    this.htmlElement = root.querySelector("html")
    root.addEventListener("scroll", (e) => { this._bodyScrollListener(e) })
  }

  _bodyScrollListener(e){
    // scroll-padding-top should be checked on scroll because it's not guaranteed to be set on the initialize()
    // function for this component
    if(this.htmlElement.style["scroll-padding-top"]) {
      this.scrollPaddingTop = parseInt(this.htmlElement.style["scroll-padding-top"].split("px")[0])
    } else {
      this.scrollPaddingTop = 0
    }

    this.links.forEach((l) => { l.classList.remove(this.activeAnchorClassValue) })

    const linksToVisibleAnchors = this.links.
      filter((link) => {
        const rect = this.linkToAnchorMap[link].getBoundingClientRect()
        const adjustedTop = rect.top
        const adjustedBottom = rect.bottom - this.scrollPaddingTop
        return (adjustedTop >= 0 && adjustedTop <= window.innerHeight) || (adjustedTop <= 0 && adjustedBottom >= 0)      })

    const linkForTopmostAnchor = linksToVisibleAnchors.sort((a, b) => {
      return this.linkToAnchorMap[a].getBoundingClientRect().top - this.linkToAnchorMap[b].getBoundingClientRect().top
    })[0]

    if(!linkForTopmostAnchor) { return }

    linkForTopmostAnchor.classList.add(this.activeAnchorClassValue)
  }
}
